import React from 'react';
import { TextField, Button, Grid, Paper, Typography } from '@mui/material';


const product_fields = [
    { id: 'poIdStrg', label: "PO NUMBER", align: 'center', minWidth: 150 },
    { id: 'lineNo', label: "POL", align: 'center', minWidth: 150 },
    { id: 'comProdIdStrg', label: "MATERIAL CODE", align: 'center', minWidth: 150 },
    { id: 'mfrName', label: "ORIGINAL MNFR", align: 'center', minWidth: 150 },
    { id: 'prodName', label: "DESCRIPTION", align: 'center', minWidth: 150 },
    { id: 'prodStatus', label: "STATUS", align: 'left', minWidth: 120 },
    { id: 'orderedQty', label: "PO QTY", align: 'center', minWidth: 120 },
    { id: 'deliveredQty', label: "DELIVERED QTY", align: 'center', minWidth: 120 },
    { id: 'balQty', label: "REMAINING QTY", align: 'center', minWidth: 120 },
    { id: 'do', label: "No of DO", align: 'center', minWidth: 100 },
    { id: 'estTimeArr', label: "ETA", align: 'center', minWidth: 120 },
    { id: 'expecDelDate', label: "ETD", align: 'center', minWidth: 120 },
    { id: 'delLocation', label: "DELIVERY LOCATION", align: 'center', minWidth: 120 },
    { id: 'isPaid', label: "PAYMENT STATUS", align: 'center', minWidth: 120 },
    { id: 'amtcRemarks', label: "AMTC REMARKS", align: 'center', minWidth: 120, showIcon: true },
    { id: 'clientRemarks', label: "CLIENT REMARKS", align: 'center', minWidth: 120, showIcon: true },
];

const delivery_order_fields = [
    { id: 'doIdStrg', label: "DO NUMBER", align: 'center', minWidth: 50 },
    { id: 'doLineNo', label: "DOL", align: 'center', minWidth: 30 },
    { id: 'deliveredQty', label: "QTY", align: 'center', minWidth: 30 },
    { id: 'deliveredAt', label: "DELIVERED ON", align: 'center', minWidth: 30 },
    { id: 'invStatus', label: "INVOICE STATUS", align: 'center', minWidth: 30 },
    { id: 'invNo', label: "INVOICE NO", align: 'center', minWidth: 30 },
    { id: 'invDate', label: "INVOICE DATE", align: 'center', minWidth: 30 },
];


const renderDeliveryOrderFields = (field) => (
    <Grid item xs={12} sm={6} md={4} key={field.id}>
        <TextField
            id={field.id}
            label={field.label}
            fullWidth
            variant="outlined"
            margin="normal"
        />
    </Grid>
);

const AddPOPage = () => {
    const renderTextField = (field) => (
        <Grid item xs={12} sm={6} md={4} key={field.id}>
            <TextField
                id={field.id}
                label={field.label}
                fullWidth
                variant="outlined"
                margin="normal"
            />
        </Grid>
    );

    return (
        <Paper style={{ padding: 16 }}>
            <Typography variant="h6" gutterBottom>
                Add Purchase Order
            </Typography>
            <form noValidate autoComplete="off">
                <Grid container spacing={3}>
                    {product_fields.map(renderTextField)}
                </Grid>
                <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
                    Delivery Orders
                </Typography>
                <Grid container spacing={3}>
                    {delivery_order_fields.map(renderDeliveryOrderFields)}
                </Grid>
                <Button variant="contained" color="primary" style={{ marginTop: 16 }}>
                    Submit
                </Button>
            </form>
        </Paper>
    );
};

export default AddPOPage;